import { cancelFollow, createFollow, delRelease, getSetsList } from "@/pages/Space/api/mySpace";
import React, { useEffect, useMemo, useState } from "react";
import { useAsyncEffect } from "ahooks";
import { mySpaceStore } from "../../MySpace/store";
import styles from "./index.module.scss";
import { ImgAndPromptItemType } from "@/stores/gallery";
import { observer } from "mobx-react-lite";
import { Sets } from "@/types/mySpace";
import PubItem from "../PubItem";
import useColumn from "../../hook/useColumn";
import GalleryDetail from "@/pages/Gallery/components/GalleryDetail";
import { cloneDeep } from "lodash";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  useDisclosure,
  Button,
} from "@chakra-ui/react";
import FollowItem from "../FollowItem";
import EmptyContent from "../EmptyContent";

const Follow: React.FC = () => {
  const [curIdx, setCurIdx] = useState<number>(1);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    loading: mySpaceLoading,
    followNoMore,
    followList,
    getFollowList,
    setFollowList,
  } = mySpaceStore;

  // const cancelRef = React.useRef();
  const column = useColumn();
  useEffect(() => {
    setFollowList([]);
    getFollowList(curIdx, callback);
    function callback() {
      setCurIdx(curIdx + 1);
      if (firstLoad) setFirstLoad(false);
    }
  }, []);

  const handleLoadMore = () => {
    getFollowList(curIdx);
  };

  const handleFollow = async (id: string | number) => {
    const res = await createFollow({ to_user_id: String(id) });
    if (res.code === 0) {
      // success
    } else {
      // error
    }
  };

  const handleCancelFollow = async (id: string | number) => {
    const res = await cancelFollow({ to_user_id: String(id) });
    if (res.code === 0) {
      // success
    } else {
      // error
    }
  };

  return (
    <div className={styles["follow-wrapper"]}>
      <div
        className={styles["data-list-wrapper"]}
        style={{ gridTemplateColumns: `repeat(${column}, 1fr)` }}
      >
        {followList.map((itemInfo, idx) => (
          <FollowItem
            key={idx}
            info={itemInfo}
            handleFollow={handleFollow}
            handleCancelFollow={handleCancelFollow}
          />
        ))}
      </div>
      {!mySpaceLoading && !firstLoad && (
        <div className={styles["add-more-wrapper"]}>
          {!followNoMore && (
            <button onClick={handleLoadMore} className={styles["add-more-btn"]}>
              加载更多
            </button>
          )}
          {followNoMore && followList.length !== 0 && (
            <div className={styles["no-more"]}>没有更多了</div>
          )}
        </div>
      )}

      {followList.length === 0 && !firstLoad && (
        <EmptyContent
          firstContent="您还没有关注过任何人"
          secondContent="可以关注您喜欢的艺术家并关注ta的最新状态!"
        />
      )}

      {/* <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef as any}
        onClose={onClose}
        isOpen={isOpen}
        size={"3xl"}
        isCentered>
        <AlertDialogOverlay />
        <AlertDialogContent
          color={"#fff"}
          backgroundColor={"#27272A"}
          borderRadius={"20px"}
          paddingBottom={"34px"}>
          <AlertDialogCloseButton />
          <AlertDialogBody
            fontSize={"20px"}
            fontWeight={500}
            textAlign={"center"}
            marginBottom={"67px"}
            paddingTop={"90px"}>
            作品删除后将不可恢复😳您确定要删除吗?
          </AlertDialogBody>
          <div className={styles["footer-wrapper"]}>
            <button className={styles["footer-btn"]} onClick={onClose}>
              返回空间
            </button>
            <button
              className={`${styles["footer-btn"]} ${styles["dangerous"]}`}
              onClick={handleDelete}>
              狠心删除
            </button>
          </div>
        </AlertDialogContent>
      </AlertDialog> */}
    </div>
  );
};

export default observer(Follow);
